import useDataQuery from '../../hooks/useDataQuery/useDataQuery';
import { DropboxFolder } from './DropboxTypes';
import { dropboxRepository } from './dropbox.repository';

const DROPBOX_FOLDERS_QUERY_KEY = ['dropbox', 'folders'] as const;

const useDropboxFolders = () => {
  const foldersQuery = useDataQuery<DropboxFolder[]>(
    {
      queryKey: DROPBOX_FOLDERS_QUERY_KEY,
      queryFn: async () => {
        const response = await dropboxRepository().getFolders();

        if (!response.ok || !response.data) {
          return [];
        }

        return response.data;
      },
    },
    { enabled: false },
  );

  const synchronizeFolders = async (): Promise<void> => {
    await foldersQuery.refetch();
  };

  return {
    folders: foldersQuery.data ?? [],
    isLoadingFolders: foldersQuery.isFetching,
    synchronizeFolders,
  };
};

export default useDropboxFolders;
